import React from "react";
import styles from "./index.module.scss";
import type { Permission } from "@/types/modular-permissions.types";
import type { Config, UseAccountReturnType } from "wagmi";
import classNames from "classnames";
import LoadingIndicatorCard from "@/features/mod-perms/components/cards/loading-card/loading-indicator-card";
import MirroredDelegationList from "@/features/mod-perms/components/lists/mirrored-list";
import NoPermsExistCard from "@/features/mod-perms/components/cards/no-perms-card/no-perms-card";
type Props = {
  accountStatus: UseAccountReturnType<Config>;
  isLoading: boolean;
  permissions: Permission[];
};

const MirroredBlock = ({ isLoading, permissions, accountStatus }: Props) => {
  return (
    <div className={classNames(styles.sectionWrapper, styles.mirroredBlock)}>
      <div className={styles.headerWrapper}>
        <p className={styles.listHeaderMirrored}>Mirrored Permissions</p>
        <hr />
      </div>
      {isLoading ? (
        <LoadingIndicatorCard />
      ) : (
        <>
          <MirroredDelegationList
            permissions={permissions}
            isLoading={isLoading}
            accountStatus={accountStatus}
          />
          <NoPermsExistCard
            isLoading={isLoading}
            permissions={permissions}
            mirroredCard
            accountStatus={accountStatus}
          />
        </>
      )}
    </div>
  );
};

export default MirroredBlock;
